module.exports = __webpack_public_path__ + "static/cuda-b6dad4149848ff4812da8ab20a234252.svg";